/**
 * Web.Api
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ApplicationWarrantyClaimsGetByIdWarrantyClaimDetailsResponse { 
    id?: string | null;
    customerId?: string | null;
    customerName?: string | null;
    warrantyClaimTypeId?: string | null;
    warrantyClaimTypeLabel?: string | null;
    managerName?: string | null;
    comment?: string | null;
    orderNumber?: number | null;
    isInvoiced?: boolean;
    receivedAt?: string;
    processedAt?: string | null;
}

